// @flow

import {
  base64UrlToUint8Array,
  arrayBufferToBase64Url,
} from '../../pix-jsr-enrollment/services/webauthn';
import type { AssertionOptions } from '../types';

export { getWebAuthnErrorMessage } from '../../pix-jsr-enrollment/services/webauthn';

export type AssertionResponse = {|
  +credentialId: string,
  +rawCredentialId: string,
  +credentialType: string,
  +response: {|
    +clientDataJSON: string,
    +authenticatorData: string,
    +signature: string,
    +userHandle: string,
  |},
|};

export function buildAssertionOptions(assertionOptions: AssertionOptions): { ... } {
  return {
    challenge: base64UrlToUint8Array(assertionOptions.challenge),
    rpId: assertionOptions.rpId || 'ebanx.com',
    timeout: assertionOptions.timeout ?? 60000,
    userVerification: assertionOptions.userVerification || 'preferred',
  };
}

// $FlowFixMe[unclear-type] — credential is a PublicKeyCredential from navigator.credentials.get()
export function extractAssertionResponse(credential: Object): AssertionResponse {
  return {
    credentialId: credential.id,
    rawCredentialId: arrayBufferToBase64Url(credential.rawId),
    credentialType: credential.type,
    response: {
      clientDataJSON: arrayBufferToBase64Url(credential.response.clientDataJSON),
      authenticatorData: arrayBufferToBase64Url(credential.response.authenticatorData),
      signature: arrayBufferToBase64Url(credential.response.signature),
      userHandle: credential.response.userHandle ? arrayBufferToBase64Url(credential.response.userHandle) : '',
    },
  };
}
